/**
 * FANPLAZA Search Drawer
 *
 * States (markup in sections/fanplaza-header.liquid, styles in fanplaza-search.css):
 *   idle  popular terms, browse tiles, recently viewed
 *   live  predictive results while typing: suggest.json (products, collections, queries)
 *   full  every result after Enter / "Show all": Section Rendering API
 *         /search?q=..&type=product&section_id=fp-search-results (+ Load more)
 *
 * Enter never leaves the page. The classic /search template stays reachable
 * for direct links only.
 */
(function () {
  'use strict';

  var overlay = document.getElementById('fp-search-overlay');
  if (!overlay) return;

  var $ = function (sel, root) { return (root || overlay).querySelector(sel); };
  var $$ = function (sel, root) { return Array.prototype.slice.call((root || overlay).querySelectorAll(sel)); };

  var form = $('[data-search-form]');
  var input = $('#fp-search-input');
  var body = $('[data-search-body]');
  var meta = $('[data-search-meta]');
  var clearBtn = $('[data-search-clear]');
  var states = { idle: $('[data-state="idle"]'), live: $('[data-state="live"]'), full: $('[data-state="full"]') };
  var emptyEl = $('[data-search-empty]');
  var recentWrap = $('[data-search-recent]');
  var recentGrid = $('[data-search-recent-grid]');
  var queriesWrap = $('[data-search-queries]');
  var queriesList = $('[data-search-queries-list]');
  var collsWrap = $('[data-search-colls]');
  var collsList = $('[data-search-colls-list]');
  var liveGrid = $('[data-search-live-grid]');
  var liveFoot = $('[data-search-live-foot]');
  var liveCount = $('[data-search-live-count]');
  var showAllBtn = $('[data-search-showall]');
  var fullTitle = $('[data-search-full-title]');
  var fullGrid = $('[data-search-full-grid]');
  var moreBtn = $('[data-search-more]');
  var headerOuter = overlay.closest('.fp-header-outer');
  var wrapper = headerOuter
    ? headerOuter.querySelector('.fp-header-wrapper') || headerOuter.querySelector('fanplaza-sticky-header')
    : null;

  if (!input || !body) return;

  var LIMIT = parseInt(overlay.dataset.resultsLimit, 10) || 8;
  var RECENT_KEY = 'rpt_recently_viewed';
  var RECENT_MAX = 8;
  var SECTION_ID = 'fp-search-results';
  var PAGE_SIZE = 24;

  var state = 'idle';
  var term = '';
  var debounceTimer = null;
  var liveCtrl = null;
  var fullCtrl = null;
  var predictiveCache = {};
  var fullCache = {};      // term -> { count, pages, pages: {1: html, 2: html} }
  var recentLoaded = false;

  /* ── helpers ─────────────────────────────────────────────────────────── */
  function esc(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* suggest.json returns a bare amount ("85.00"); products/<handle>.js returns cents */
  function money(amount, isCents) {
    var n = isCents ? amount / 100 : parseFloat(String(amount).replace(/[^0-9.]/g, ''));
    if (isNaN(n)) return '';
    return '€' + n.toLocaleString('de-DE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  function imgSize(url, w) {
    if (!url) return '';
    return url.replace(/(\.[a-z]+)(\?.*)?$/i, '_' + w + 'x$1$2');
  }

  function cardHtml(p) {
    var out = !p.available;
    var html = '<a href="' + esc(p.url) + '" class="fp-search-card' + (out ? ' fp-search-card--out' : '') + '" data-available="' + (out ? 'false' : 'true') + '">';
    html += '<div class="fp-search-card__media">';
    if (p.image) {
      html += '<img src="' + esc(imgSize(p.image, 480)) + '" srcset="' + esc(imgSize(p.image, 320)) + ' 320w, ' + esc(imgSize(p.image, 480)) + ' 480w, ' + esc(imgSize(p.image, 640)) + ' 640w" sizes="(max-width: 989px) 45vw, 240px" alt="' + esc(p.title) + '" loading="lazy" width="480" height="600">';
    }
    html += '</div><div class="fp-search-card__info">';
    html += '<p class="fp-search-card__title">' + esc(p.title) + '</p>';
    html += '<p class="fp-search-card__price">' + esc(p.price) + (out ? ' <span class="fp-search-card__out">Sold out</span>' : '') + '</p>';
    html += '</div></a>';
    return html;
  }

  function setState(next) {
    state = next;
    Object.keys(states).forEach(function (k) {
      if (states[k]) states[k].hidden = k !== next;
    });
    body.scrollTop = 0;
  }

  function setMeta(text) {
    if (!meta) return;
    meta.textContent = text || '';
    meta.hidden = !text;
  }

  function setLoading(on) {
    if (on) overlay.setAttribute('data-loading', 'true');
    else overlay.removeAttribute('data-loading');
  }

  function abort(ctrl) { if (ctrl) { try { ctrl.abort(); } catch (e) { /* noop */ } } }

  /* ── open / close ────────────────────────────────────────────────────── */
  function openSearch() {
    overlay.setAttribute('aria-hidden', 'false');
    if (wrapper) wrapper.classList.add('fp-search-open');
    document.documentElement.classList.add('fp-search-active');
    if (state === 'idle') loadRecent();
    requestAnimationFrame(function () { input.focus(); });
  }

  function closeSearch() {
    if (overlay.getAttribute('aria-hidden') === 'true') return;
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('fp-search-active');
    setTimeout(function () { if (wrapper) wrapper.classList.remove('fp-search-open'); }, 300);
    setTimeout(resetToIdle, 300);
  }

  /* Header + drawers call this to close the search from outside */
  window.fpCloseSearch = closeSearch;

  function resetToIdle() {
    abort(liveCtrl); abort(fullCtrl);
    if (debounceTimer) clearTimeout(debounceTimer);
    term = '';
    input.value = '';
    clearBtn.hidden = true;
    emptyEl.hidden = true;
    setMeta('esc');
    setLoading(false);
    setState('idle');
  }

  /* ── idle: recently viewed ───────────────────────────────────────────── */
  function loadRecent() {
    if (recentLoaded || !recentGrid) return;
    recentLoaded = true;
    var handles = [];
    try { handles = JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); } catch (e) { handles = []; }
    if (!Array.isArray(handles) || !handles.length) return;
    handles = handles.slice(0, RECENT_MAX);

    Promise.all(handles.map(function (h) {
      return fetch('/products/' + encodeURIComponent(h) + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (list) {
      var html = list.filter(Boolean).map(function (p) {
        return cardHtml({
          url: '/products/' + p.handle,
          title: p.title,
          price: money(p.price, true),
          available: p.available,
          image: p.featured_image
        });
      }).join('');
      if (!html) return;
      recentGrid.innerHTML = html;
      recentWrap.hidden = false;
    });
  }

  /* ── live: predictive ────────────────────────────────────────────────── */
  function onInput() {
    var q = input.value.trim();
    clearBtn.hidden = q.length === 0;
    if (debounceTimer) clearTimeout(debounceTimer);

    if (q.length < 2) {
      abort(liveCtrl); abort(fullCtrl);
      term = '';
      emptyEl.hidden = true;
      setMeta('esc');
      setLoading(false);
      setState('idle');
      return;
    }

    debounceTimer = setTimeout(function () { runLive(q); }, 250);
  }

  function runLive(q) {
    if (q === term && state === 'live') return;
    term = q;
    setMeta('');

    if (predictiveCache[q]) {
      renderLive(predictiveCache[q], q);
      warmFull(q);
      return;
    }

    abort(liveCtrl);
    liveCtrl = new AbortController();
    setLoading(true);

    var url = '/search/suggest.json?q=' + encodeURIComponent(q)
      + '&resources[type]=product,collection,query'
      + '&resources[limit]=' + LIMIT
      + '&resources[limit_scope]=each'
      + '&resources[options][unavailable_products]=last'
      + '&resources[options][fields]=title,product_type,variants.title,vendor,tag';

    fetch(url, { signal: liveCtrl.signal })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var res = (data.resources && data.resources.results) || {};
        var payload = {
          products: (res.products || []).slice(0, LIMIT),
          collections: (res.collections || []).slice(0, 3),
          queries: (res.queries || []).slice(0, 4)
        };
        predictiveCache[q] = payload;
        if (q !== term) return;
        renderLive(payload, q);
        warmFull(q);
      })
      .catch(function (err) {
        if (err && err.name === 'AbortError') return;
        setLoading(false);
        showEmpty('Something went wrong. Please try again.');
      });
  }

  function renderLive(data, q) {
    setLoading(false);

    if (!data.products.length) {
      showEmpty('No objects for “' + esc(q) + '”. Try one of these:');
      return;
    }

    emptyEl.hidden = true;

    /* rail: query suggestions */
    var qs = data.queries.filter(function (s) { return s.text && s.text.toLowerCase() !== q.toLowerCase(); });
    if (qs.length) {
      queriesList.innerHTML = qs.map(function (s) {
        var t = s.text;
        var head = t.toLowerCase().indexOf(q.toLowerCase()) === 0 ? t.slice(0, q.length) : '';
        var rest = head ? t.slice(q.length) : t;
        return '<li><button type="button" class="fp-search-list__item" data-search-suggest="' + esc(t) + '">'
          + '<span>' + esc(head) + '<span class="fp-search-list__rest">' + esc(rest) + '</span></span>'
          + '</button></li>';
      }).join('');
      queriesWrap.hidden = false;
    } else {
      queriesWrap.hidden = true;
    }

    /* rail: matching collections */
    if (data.collections.length) {
      collsList.innerHTML = data.collections.map(function (c) {
        var img = c.featured_image && c.featured_image.url ? imgSize(c.featured_image.url, 120) : '';
        return '<a href="' + esc(c.url) + '" class="fp-search-tile">'
          + (img ? '<img class="fp-search-tile__img" src="' + esc(img) + '" alt="" width="40" height="40" loading="lazy">' : '')
          + '<span class="fp-search-tile__text"><span class="fp-search-tile__label">' + esc(c.title) + '</span><span class="fp-search-tile__sub fp-search-tile__sub--muted">Collection</span></span></a>';
      }).join('');
      collsWrap.hidden = false;
    } else {
      collsWrap.hidden = true;
    }

    /* grid */
    liveGrid.innerHTML = data.products.map(function (p) {
      return cardHtml({ url: p.url, title: p.title, price: money(p.price), available: p.available, image: p.image });
    }).join('');

    states.live.classList.toggle('is-no-rail', queriesWrap.hidden && collsWrap.hidden);
    liveCount.innerHTML = '<b>' + data.products.length + '</b> objects';
    showAllBtn.innerHTML = 'Show all results' + arrow();
    liveFoot.hidden = false;
    setState('live');
  }

  function showEmpty(msg) {
    emptyEl.innerHTML = msg;
    emptyEl.hidden = false;
    setState('idle');
  }

  function arrow() {
    return ' <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6"/></svg>';
  }

  /* ── full: Section Rendering API ─────────────────────────────────────── */
  function fullUrl(q, page) {
    return '/search?q=' + encodeURIComponent(q) + '&type=product&options%5Bprefix%5D=last&page=' + page + '&section_id=' + SECTION_ID;
  }

  function parsePage(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var page = doc.querySelector('[data-search-page]');
    if (!page) return null;
    /* sold-out objects go to the end of their page */
    var cards = Array.prototype.slice.call(page.querySelectorAll('.fp-search-card'));
    var inStock = cards.filter(function (c) { return c.dataset.available === 'true'; });
    var out = cards.filter(function (c) { return c.dataset.available !== 'true'; });
    return {
      count: parseInt(page.dataset.count, 10) || 0,
      page: parseInt(page.dataset.page, 10) || 1,
      pages: parseInt(page.dataset.pages, 10) || 1,
      html: inStock.concat(out).map(function (c) { return c.outerHTML; }).join('')
    };
  }

  function fetchFull(q, page) {
    var entry = fullCache[q] || (fullCache[q] = { count: null, pages: 1, html: {} });
    if (entry.html[page]) return Promise.resolve(entry);

    abort(fullCtrl);
    fullCtrl = new AbortController();

    return fetch(fullUrl(q, page), { signal: fullCtrl.signal })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var parsed = parsePage(html);
        if (!parsed) throw new Error('no section');
        entry.count = parsed.count;
        entry.pages = parsed.pages;
        entry.html[page] = parsed.html;
        return entry;
      });
  }

  /* After a predictive render, fetch page 1 of the full result in the
     background so the count shows up and Enter is instant. */
  function warmFull(q) {
    fetchFull(q, 1).then(function (entry) {
      if (q !== term || state !== 'live') return;
      var shown = liveGrid.querySelectorAll('.fp-search-card').length;
      liveCount.innerHTML = '<b>' + shown + '</b> of ' + entry.count + ' objects';
      showAllBtn.innerHTML = 'Show all ' + entry.count + ' results' + arrow();
    }).catch(function () { /* count stays generic */ });
  }

  function showFull(q) {
    if (!q) return;
    term = q;
    setLoading(true);
    fetchFull(q, 1).then(function (entry) {
      if (q !== term) return;
      setLoading(false);
      renderFull(entry, q, 1);
    }).catch(function (err) {
      if (err && err.name === 'AbortError') return;
      setLoading(false);
      showEmpty('Something went wrong. Please try again.');
    });
  }

  function renderFull(entry, q, upToPage) {
    var html = '';
    for (var p = 1; p <= upToPage; p++) html += entry.html[p] || '';
    fullGrid.innerHTML = html;
    fullGrid.classList.remove('is-available-only');
    $$('[data-search-filter]').forEach(function (b) { b.classList.toggle('is-on', b.dataset.searchFilter === 'all'); });

    if (entry.count === 0) {
      showEmpty('No objects for “' + esc(q) + '”. Try one of these:');
      return;
    }

    fullTitle.innerHTML = entry.count + ' objects <span>for “' + esc(q) + '”</span>';
    setMeta(entry.count + ' results');
    emptyEl.hidden = true;
    moreBtn.hidden = upToPage >= entry.pages;
    moreBtn.dataset.next = upToPage + 1;
    moreBtn.textContent = 'Load ' + Math.min(PAGE_SIZE, entry.count - upToPage * PAGE_SIZE) + ' more';
    setState('full');
  }

  function loadMore() {
    var next = parseInt(moreBtn.dataset.next, 10) || 2;
    var q = term;
    moreBtn.disabled = true;
    fetchFull(q, next).then(function (entry) {
      if (q !== term) return;
      var frag = document.createElement('div');
      frag.innerHTML = entry.html[next] || '';
      while (frag.firstChild) fullGrid.appendChild(frag.firstChild);
      if (fullGrid.classList.contains('is-available-only')) { /* CSS handles hiding */ }
      moreBtn.hidden = next >= entry.pages;
      moreBtn.dataset.next = next + 1;
      moreBtn.textContent = 'Load ' + Math.min(PAGE_SIZE, entry.count - next * PAGE_SIZE) + ' more';
    }).catch(function () { /* keep button */ })
      .then(function () { moreBtn.disabled = false; });
  }

  /* ── wiring ──────────────────────────────────────────────────────────── */
  $$('[data-search-open]', document).forEach(function (btn) {
    btn.addEventListener('click', function (e) { e.preventDefault(); openSearch(); });
  });

  $$('[data-search-close]').forEach(function (btn) { btn.addEventListener('click', closeSearch); });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.getAttribute('aria-hidden') === 'false') closeSearch();
  });

  clearBtn.addEventListener('click', function () {
    input.value = '';
    onInput();
    input.focus();
  });

  input.addEventListener('input', onInput);

  /* Enter stays in the drawer */
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var q = input.value.trim();
    if (q.length < 2) return;
    if (debounceTimer) clearTimeout(debounceTimer);
    showFull(q);
  });

  showAllBtn.addEventListener('click', function () { showFull(input.value.trim()); });
  moreBtn.addEventListener('click', loadMore);

  /* popular chips + query suggestions: fill input, search, keep focus */
  overlay.addEventListener('click', function (e) {
    var chip = e.target.closest('[data-search-term], [data-search-suggest]');
    if (!chip) return;
    var t = chip.dataset.searchTerm || chip.dataset.searchSuggest;
    if (!t) return;
    input.value = t;
    clearBtn.hidden = false;
    if (debounceTimer) clearTimeout(debounceTimer);
    if (chip.dataset.searchTerm !== undefined) showFull(t);
    else runLive(t);
    input.focus();
  });

  $$('[data-search-filter]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var mode = btn.dataset.searchFilter;
      fullGrid.classList.toggle('is-available-only', mode === 'available');
      $$('[data-search-filter]').forEach(function (b) { b.classList.toggle('is-on', b === btn); });
    });
  });

  setMeta('esc');
})();
